import type { Disposable } from '@patsnap/tahiti-core';

/** 通用按钮操作引导的可选视觉配置。 */
export interface OnboardingActionGuideOptions {
    /** 是否为每个目标挂载点击手型；默认展示。 */
    showHand?: boolean;
}

/** 通用按钮操作引导 service。 */
export interface OnboardingActionGuideService {
    /**
     * 为目标元素展示呼吸波纹和点击手型。
     * @param targets 需要同时提示的目标元素。
     * @param options 可选视觉配置。
     * @returns 用于完整清理样式和动态挂载节点的句柄。
     */
    show(targets: readonly Element[], options?: OnboardingActionGuideOptions): Disposable;
}

/** 通用按钮操作引导 service 的容器标识。 */
export const OnboardingActionGuideService = Symbol('OnboardingActionGuideService');
